module.exports = __webpack_public_path__ + "6649d37c7a3a329ed26a0fabfc5b76a6.svg";